//Quick View

$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function quickView() {
  $(".quick-view").click(function (e) {
    e.preventDefault();
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      var shop_curr = $('[data-shop-currency]').attr('data-shop-currency');
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      $(options).each(function (i, option) {
          var opt = option.name;
          var indx_par = i;
          var selectClass = '.option.' + opt.toLowerCase();
          $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
          $(option.values).each(function (i, value) {
            $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
          });
        if (opt.toLowerCase().indexOf('title') == -1) {
          console.log('called opt', opt.toLowerCase())
          $('.qv-product-options-custom').append('<div class="swatches-wrapper col-md-12"><fieldset><legend class="swatch-title">' + opt.toLowerCase() + '</legend><div class="swatch clearfix" data-option-index="' + indx_par + '"></div></fieldset></div>');
          $(option.values).each(function (i, value) {
            console.log('ind', $('[data-option-index='+indx_par+'].swatch'));
            var checked_is = '';
            if (i == 0) {
              var checked_is = 'checked';
            }
            $('[data-option-index='+indx_par+'].swatch').append('<div data-value="' + value + '" class="swatch-element ' + value.toLowerCase() + ' available"><input id="swatch-' + indx_par + '-' + value + '" type="radio" name="option-' + indx_par + '" data-index="'+indx_par+'" value="'+value+'" class="wetheme-custom-radio"'+checked_is+'><label for="swatch-' + indx_par + '-' + value + '">' + value + '<img class="crossed-out" src="//jonesanddaughters.co/cdn/shop/t/20/assets/soldout.svg?v=76651119936436619561696487162" alt=""></label></div>');
          });
        }
      });
      $('.qv-product-options-custom input').on('change', function() {
          // console.log($(this).attr('value'), $('.qv-product-options select option[value="'+$(this).attr('value')+'"]'), $('.qv-product-options input[value="Navy"]'));
          // $('.qv-product-options select option[value="'+$(this).attr('value')+'"]').trigger('click');
          // console.log($(this).attr('data-index')+')
           $('.qv-product-options select.option-'+$(this).attr('data-index')).val($(this).attr('value')).change();
      });
      $(product.variants).each(function (i, v) {
        console.log('v', v)
        if (v.inventory_quantity == 0) {
          console.log(v.public_title)
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').text(shop_curr + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text(shop_curr + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });

    $(document).on("change", "#quick-view select", function () {
      var shop_curr = $('[data-shop-currency]').attr('data-shop-currency');
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      console.log('selectedOptions', selectedOptions)
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          console.log('pro', product)
        $(product.variants).each(function (i, v) {
          console.log('v', v)
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            $('.qv-product-price').text(shop_curr + price);
            $('.qv-product-original-price').text(shop_curr + original_price);
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
              if (v.inventory_quantity < 1 || !v.available) {
                $('.qv-add-button').prop('disabled', true).val('Sold Out');
                console.log('v 2nd', v)
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              }
            }
            return false;
          }
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
                        null,
                        "json"
                       ).done(function () {
              $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
          console.log($('#quick-view select'));
          $('#quick-view select').trigger('change');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});